import { createSlice } from '@reduxjs/toolkit';
import { getAuthenticateData } from '../../library/helpers/utility';

const notificationSetOperatorInitialState = {
  idOperator:
    getAuthenticateData() !== null && getAuthenticateData() !== undefined
      ? getAuthenticateData().authenticate.scaAccount.id
      : null,
};

export const notificationSetOperatorSlice = createSlice({
  name: 'notificationSetOperator',
  initialState: notificationSetOperatorInitialState,
  reducers: {
    changeIdOperator: (state, action) => {
      state.idOperator = action.payload.idOperator;
    },
    resetIdOperator: (state) => {
      state.idOperator =
        getAuthenticateData() !== null && getAuthenticateData() !== undefined
          ? getAuthenticateData().authenticate.scaAccount.id
          : null;
    },
  },
});

export const { changeIdOperator, resetIdOperator } =
  notificationSetOperatorSlice.actions;

export default notificationSetOperatorSlice.reducer;
